/* FL Boxy — „Ile przekąsek w paczce?” (sections/fl-boxy-tally.liquid):
   kwadraciki wskakują kolejno, gdy lista wjedzie na ekran (klasa is-in). */
(() => {
  'use strict';

  if (customElements.get('fl-boxy-tally')) return;

  class FLBoxyTally extends HTMLElement {
    connectedCallback() {
      if (this.classList.contains('is-in')) return;
      const list = this.querySelector('.fl-boxy-tally__list');
      const designMode = window.Shopify && window.Shopify.designMode;
      if (!list || designMode || !('IntersectionObserver' in window)) {
        this.classList.add('is-in');
        return;
      }
      this.seen = new IntersectionObserver((entries) => {
        if (!entries.some((x) => x.isIntersecting)) return;
        this.classList.add('is-in');
        this.seen.disconnect();
      }, { rootMargin: '0px 0px -12% 0px' });
      this.seen.observe(list);
    }

    disconnectedCallback() {
      if (this.seen) this.seen.disconnect();
    }
  }

  customElements.define('fl-boxy-tally', FLBoxyTally);
})();
